import {
  GET_SUPPLIERS,
  ADD_SUPPLIER,
  UPDATE_SUPPLIER,
  DELETE_SUPPLIER,
  SELECT_SUPPLIER,
} from "../actions/types";

const initialState = {
  suppliers: [],
  selectedSupplier: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SUPPLIERS:
      return {
        ...state,
        suppliers: payload,
      };
    case ADD_SUPPLIER:
      return {
        ...state,
        suppliers: [...state.suppliers, payload],
      };
    case UPDATE_SUPPLIER:
      return {
        ...state,
        suppliers: state.suppliers.map((supplier) => {
          if (payload.id !== supplier.id) {
            return supplier;
          }

          return {
            ...supplier,
            payload,
          };
        }),
      };
    case SELECT_SUPPLIER:
      return {
        ...state,
        selectedSupplier: payload,
      };
    case DELETE_SUPPLIER:
      return {
        ...state,
        suppliers: state.suppliers.filter(
          (supplier) => supplier.id !== payload
        ),
      };
    default:
      return state;
  }
}
